export const DEFAULT_THEME = 'white';
export const THEMES = ['white', 'blue'] as const;
export const DEFAULT_PADDING_HEADER = 86;
